<template>
	<div class="page-dashboard pa-1 relative">
		<div class="p-5 text-center absolute" v-if="isFetching">
			<div class="is-loading large"></div>
		</div>
		<!-- not admin -->
		<div class="container-fluid" v-if="!isFetching && !userId">
			<!-- rundown and assets -->
			<div><h2 class="text-primary mb-4 mt-6">{{ $t('My Statistics') }}</h2></div>
			<div class="cards-statistics">
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">playlist_add_check</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count font-count">{{statistics && statistics.total_rundown ? statistics.total_rundown : '0'}}</h1>
						{{$t('Total Rundown')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">image</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count font-count">{{statistics && statistics.total_media ? statistics.total_media : '0'}}</h1>
						{{$t('Total Media')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">play_arrow</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count font-count">{{statistics && statistics.total_asset ? statistics.total_asset : '0'}}</h1>
						{{$t('Total Rundown Assets')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">people</md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count font-count">{{statistics && statistics.total_collaborator ? statistics.total_collaborator : '0'}}</h1>
						{{$t('Total Collaborator')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2"><picture-in-picture-icon></picture-in-picture-icon></md-icon></div>
					<div class="text-statistics">
						<h1 class="text-count font-count">{{statistics && statistics.total_composition ? statistics.total_composition : '0'}}</h1>
						{{$t('Total Composition')}}
					</div>
				</div>
				<div class="card-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">donut_large</md-icon></div>
					<div class="text-statistics">
						<label class="text-count font-count">{{statistics && statistics.total_storage_usage ? statistics.total_storage_usage : '0'}}<span class="ml-2">Mb</span>/{{statistics && statistics.total_storage ? statistics.total_storage : '0'}}<span class="ml-2">Mb</span></label>
						{{$t('Total Storage')}}
					</div>
				</div>
			</div>
		</div>
		<!-- admin -->
		<div v-if="!isFetching && userId">
			<!-- rundown and assets -->
			<div>
				<div class="list-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">playlist_add_check</md-icon></div>
					<div class="d-flex">
						<h1 class="pt-1 text-primary">{{statistics && statistics.total_rundown ? statistics.total_rundown : '0'}}</h1>
						<div class="text-right absolute mr-5 pr-4">
							<label class="pt-3 mt-1 pl-3">{{$t('Rundown')}}</label>
						</div>
					</div>
				</div>
				<div class="list-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">image</md-icon></div>
					<div class="d-flex">
						<h1 class="pt-1 text-primary">{{statistics && statistics.total_media ? statistics.total_media : '0'}}</h1>
						<div class="text-right absolute mr-5 pr-4">
							<label class="pt-3 mt-1 pl-3">{{$t('Media')}}</label>
						</div>
					</div>
				</div>
				<div class="list-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">play_arrow</md-icon></div>
					<div class="d-flex">
						<h1 class="pt-1 text-primary">{{statistics && statistics.total_asset ? statistics.total_asset : '0'}}</h1>
						<div class="text-right absolute mr-5 pr-4">
							<label class="pt-3 mt-1 pl-3">{{$t('Rundown Assets')}}</label>
						</div>
					</div>
				</div>
				<div class="list-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">people</md-icon></div>
					<div class="d-flex">
						<h1 class="pt-1 text-primary">{{statistics && statistics.total_collaborator ? statistics.total_collaborator : '0'}}</h1>
						<div class="text-right absolute mr-5 pr-4">
							<label class="pt-3 mt-1 pl-3">{{$t('Collaborator')}}</label>
						</div>
					</div>
				</div>
				<div class="list-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2"><picture-in-picture-icon></picture-in-picture-icon></md-icon></div>
					<div class="d-flex">
						<h1 class="pt-1 text-primary">{{statistics && statistics.total_composition ? statistics.total_composition : '0'}}</h1>
						<div class="text-right absolute mr-5 pr-4">
							<label class="pt-3 mt-1 pl-3">{{$t('Composition')}}</label>
						</div>
					</div>
				</div>
				<div class="list-statistics">
					<div class="icon-statistics-wrapper"><md-icon class="icon-total-user ml-8px mt-2">donut_large</md-icon></div>
					<div class="d-flex"><h1 class="text-primary pt-1">{{statistics && statistics.total_storage_usage ? statistics.total_storage_usage : '0'}} Mb/</h1>
						<h1 class="pt-1 text-primary">{{statistics && statistics.total_storage ? statistics.total_storage : '0'}} Mb</h1>
						<div class="text-right absolute mr-5 pr-4">
							<label class="pt-3 mt-1 pl-3">{{$t('Total Storage')}}</label>
						</div>
					</div>
				</div>
				<div class="text-right">
					<button
						@click="close"
						class="btn btn-submit btn-default">
						<span>{{ $t('Close') }}</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PictureInPictureIcon from 'vue-material-design-icons/PictureInPictureBottomRightOutline.vue';
import { mapGetters } from 'vuex';
import { getAxiosErrorMessage } from '@/lib/helper';
import myStatisticsApi from '@/api/user';

export default {
	name: 'MyStatistics',
	data() {
		return {
			statistics: [],
			isFetching: false,
		};
	},
	components: {
		PictureInPictureIcon,
	},
	props: {
		userId: {
			type: Number,
		},
	},
	methods: {
		fetch() {
			this.isFetching = true;
			const callback = (response) => {
				const items = response.data;
				this.statistics = items;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'warning',
					title: 'Users',
					text: message,
				});
				this.isFetching = false;
			};
			/* eslint-disable */
			let start_date = '';
			let end_date = '';
			let user_id = '';
			if (this.userId) user_id = this.userId;
			/* eslint-enable */
			myStatisticsApi.myStatistics(start_date, end_date, user_id, callback, errorCallback);
		},
		close() {
			this.$emit('close');
		},
	},
	created() {
		this.fetch();
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
	},
	watch: {
	},
};
</script>
